import { IQuoteAnalyzed } from "models/QuoteBionexo";
import { OrdersDownloadInLotProps } from "./Orders/interface";

export interface ITable {
  trackingKey?: string;
  data?: Array<any>;
  onPageChange?: any;
  pageSize?: number;
  showPagination?: boolean;
  currentPage?: number;
  error?: boolean;
  onReload?: any;
  redirectUrl?: string;
  setTableOrder?: any;
  tableOrder?: any;
  columnsSize?: Array<number | string>;
  portalCustomHeader?: boolean;
  portalCustomRow?: boolean;
  totalPages?: number;
  completeBlankSpaces?: boolean;
  model: Array<ITableModel>;
  className?: string;
  DropdownTemplate?: any;
  bottomButton?: {
    label: string;
    linkTo: string;
  };
  customProps?: {
    [key: string]: any;
  };
  rowHeight?: number;
  exportButton?: {
    show: boolean;
    onClick: Function;
  };
  downloadInLotButton?: boolean;
  isRanking?: boolean;
  getOrdersForDownloadInLot?: any;
  ordersDownloadInLot?: OrdersDownloadInLotProps;
  totalOrder?: number;
  sentMoney?: boolean;
  newDashboard?: boolean;
  isCustomTableColor?: boolean;
  emptyDataMessage?: string;
}

export interface ITableModel {
  label: string;
  iconFilter?: JSX.Element;
  key?: string;
  tooltipText?: string;
  noFilter?: boolean;
  type?: string | "date" | "date/hour" | "currency" | "phone" | "cnpj";
  Component?: (data: any) => JSX.Element | any;
  size?: number;
  maxSize?: number;
  isButton?: boolean;
  isCenter?: boolean;
  alignRight?: boolean;
}

export interface OrderBulkDownloadProps {
  titleFirstClick: string;
  messageFirstClick: string;
  titleRequestDownload: string;
  messageRequestDownload: string;
  limit: number;
}

export interface MoneySeller {
  code: string;
  name: string;
  businessUnitIdentifier: string;
}

export interface OldSeller {
  id: string;
  businessUnits: string;
  businessUnitsIdentifier: string;
}

export interface Company {
  identifier: string;
  documentNumber: string;
  retailChain: string;
  sellers: Array<MoneySeller>;
  seller: OldSeller;
  crmCustomerCode: string;
}

export interface IQuoteOnMoney {
  id: string;
  code: string;
  createdAt: Date;
  updatedAt: Date;
  expiresAt: Date;
  itemsCount: number;
  buyerName: string;
  buyerIdentifier: string;
  origin: QuotationOriginType;
  status: StatusType;
  statusDescription: string;
  supplierStatus: SupplierStatusType;
  supplierStatusDescription: string;
  supplierStatusMessage: string;
  company: Company;
  retailChain: string;
  quoteAnalyzed: Array<IQuoteAnalyzed>;
  quoteWithAutomaticItems: boolean;
  hasItemOl: boolean;
}

export const supplierStatusValues = [
  "PENDING_MONEY",
  "ANSWERED_PORTAL",
  "ANSWERED_PORTAL_MONEY",
];

export enum QuotationOriginType {
  BIONEXO = "Bionexo",
  AMIL = "Amil",
}

export enum SupplierStatusType {
  VALIDATE_PORTAL = "Disponível",
  PENDING_MONEY = "Pendente Money",
  ANSWERED_MONEY = "Respondida Money",
  QUEUE_MONEY = "Em fila Money",
  NOT_PROCESSING_AFTER_MONEY_RETURN = "Não processado após retorno do Money",
  QUEUE_BIONEXO = "Em fila Bionexo",
  ANSWERED_PORTAL = "Respondida Portal",
  EXPIRED = "Expirada",
  CANCELED = "Cancelada",
  CREATE_ORDER = "Gerar pedido",
  DO_NOT_PARTICIPATE = "Não participar",
  ANSWERED_PORTAL_MONEY = "Respondida P/M",
  ANSWERED_BIONEXO = "Respondida Bionexo",
  WAITING_PRIORITIZATION = "Aguardando priorização",
  DISREGARDED = "Desconsiderada"
}

export enum StatusType {
  OPEN = "Aberta",
  CANCELED = "Cancelada",
  CLOSED = "Fechada",
  PROCESSING = "Processando",
  SENT = "Enviada",
  NEGOTIATION = "Negociacao",
  PURCHASE_ORDER = "Pedido",
  REOPENED = "Reaberta",
  UPDATED = "Alterada",
  UNPROCESSED = "Não processado",
}

export enum NotParticipateStatus {
  OUT_OF_STOCK = "Sem estoque",
  OUT_OF_PORTFOLIO = "Fora de portfólio",
  BLACKLIST = "Blacklist",
  FINANCIAL_BLOCK = "Bloqueio Financeiro",
  LACK_OF_DOCUMENTATION = "Falta de documentação",
  REGIONALIZED_ITEM = "Item regionalizado",
  ANSWERED_VIA_PROTHEUS = "Respondido via Protheus",
  OTHER = "Outro",
  NO_REASON_SELECTED = "Sem motivo selecionado",
}

export enum HistorytSatusDescription {
  SENT = "Enviado",
  SAVED = "Item salvo",
  DELETED = "Excluído",
  FAILURE = "Falha envio",
  NOT_DELETED = "Não excluído",
}

export const UserNamePrioritization = "Priorização";
export const noStatusBionexo = ["Aguardando priorização", "Desconsiderada"];
